import { Link } from 'react-router-dom'
import { useSiteContent, sectionField } from '../../hooks/useSiteContent'

const DEFAULTS = {
  image_1: '/assets/img/normal/about_3_1.jpg',
  image_2: '/assets/img/normal/about_3_2.jpg',
  image_3: '/assets/img/normal/about_3_3.jpg',
}

function AboutFour() {
   const { content } = useSiteContent('about')
   const c = (key, fallback) => sectionField(content, 'intro', key, fallback)

   return (
      <div className="about-area position-relative overflow-hidden overflow-hidden space" id="about-sec">
         <div className="container shape-mockup-wrap">
            <div className="row">
               <div className="col-xl-7">
                  <div className="img-box3">
                     <div className="img1">
                        <img src={c('image_1', DEFAULTS.image_1)} alt={c('title', 'About')} />
                     </div>
                     <div className="img2">
                        <img src={c('image_2', DEFAULTS.image_2)} alt="" />
                     </div>
                     <div className="img3 movingX">
                        <img src={c('image_3', DEFAULTS.image_3)} alt="" />
                     </div>
                  </div>
               </div>
               <div className="col-xl-5">
                  <div className="ps-xl-4">
                     <div className="title-area mb-20">
                        <span className="sub-title style1 ">{c('subtitle', 'Welcome To Travel With Ammar')}</span>
                        <h2 className="sec-title mb-20 pe-xl-5 me-xl-5 heading">
                           {c('title', 'We are world reputeted travel agency')}
                        </h2>
                     </div>
                     <p className="pe-xl-5">{c('body_1', 'There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words.')}</p>
                     <p className="mb-30 pe-xl-5">{c('body_2', 'Leiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.')}</p>
                     <div className="about-item-wrap">
                        <div className="about-item style2">
                           <div className="about-item_img">
                              <img src="/assets/img/icon/about_1_1.svg" alt="" />
                           </div>
                           <div className="about-item_centent">
                              <h5 className="box-title">{c('feature_1_title', 'Exclusive Trip')}</h5>
                              <p className="about-item_text">{c('feature_1_text', 'There are many variations of passages of available but the majority.')}</p>
                           </div>
                        </div>
                        <div className="about-item style2">
                           <div className="about-item_img">
                              <img src="/assets/img/icon/about_1_2.svg" alt="" />
                           </div>
                           <div className="about-item_centent">
                              <h5 className="box-title">{c('feature_2_title', 'Safety First Always')}</h5>
                              <p className="about-item_text">{c('feature_2_text', 'There are many variations of passages of available but the majority.')}</p>
                           </div>
                        </div>
                        <div className="about-item style2">
                           <div className="about-item_img">
                              <img src="/assets/img/icon/about_1_3.svg" alt="" />
                           </div>
                           <div className="about-item_centent">
                              <h5 className="box-title">{c('feature_3_title', 'Professional Guide')}</h5>
                              <p className="about-item_text">{c('feature_3_text', 'There are many variations of passages of available but the majority.')}</p>
                           </div>
                        </div>
                     </div>
                     <div className="mt-35">
                        <Link to={c('cta_url', '/contact')} className="th-btn style3 th-icon">
                           {c('cta_text', 'Contact With Us')}
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default AboutFour
